export const ICONS_TYPE: { [key: string]: string[]; } = {
  fb_ico: ['fb_ico'],
  tw_ico: ['tw_ico'],
  ig_ico: ['ig_ico'],
  in_ico: ['in_ico'],
  yt_ico: ['yt_ico'],
  lps_logo_ico: ['lps_logo_ico'],
  fac_ico: ['fac_ico'],
  people_contact_ico: ['people_contact_ico'],
  support_ico: ['support_ico'],
  contact_header_ico: ['contact_header_ico'],
  imovel_ico: ['imovel_ico'],
  search_ico: ['search_ico'],
  menu_ico: ['menu_ico'],
  close_ico: ['close_ico'],
  ruler_ico: ['ruler_ico', 'area_attr', 'total_area_attr'],
  // square_ruler_ico: ['ruler_ico', 'area_attr', 'total_area_attr'],
  bed_ico: ['bed_ico', 'bedroom_attr'],
  suite_ico: ['suite_attr'],
  sink_ico: ['sink_ico', 'bathroom_attr'],
  car_ico: ['car_ico', 'parking_lots_attr'],
  image_ico: ['image_ico'],
  heart_ico: ['heart_ico'],
  video_camera_ico: ['video_camera_ico'],
  street_view_ico: ['street_view_ico'],
  map_ico: ['map_ico'],
  see_plans_ico: ['see_plans_ico'],
  pool: ['pool'],
  diamond_ico: ['diamond_ico'],
  money_fly_ico: ['money_fly_ico'],
  house_sale_ico: ['house_sale_ico'],
  arrow_left: ['arrow_left'],
  arrow_right: ['arrow_right'],
  arrow: ['arrow'],
  arrow_up: ['arrow_up'],
  house_ico: ['house_ico'],
  dollar_ico: ['dollar_ico'],
  hand_heart_ico: ['hand_heart_ico'],
  photo_ico: ['photo_ico'],
  gym_ico: ['Academia', 'Academia de ginástica', 'Fitness'],
  party_room_ico: ['Salão de festas'],
  security_ico: ['Segurança'],
  kitchen_ico: ['Cozinha Mobiliada', 'Cozinha Americana'],
  gourmet_ico: ['Espaço Gourmet'],
  steam_room_ico: ['Sauna'],
  concierge_ico: ['Portaria'],
  parking_ico: ['Estacionamento rotativo', 'Estacionamento'],
  grill_ico: ['Churrasqueira'],
  toilet_ico: ['Lavabo'],
  heater_ico: ['Aquecedor central', 'Aquecedor'],
  laundry_ico: ['Lavanderia'],
  swimming_ico: ['Piscina infantil', 'Piscina adulto', 'Piscina'],
  elevator_ico: ['Elevador'],
  playground_ico: ['Playground', 'Brinquedoteca'],
  bike_rack_ico: ['Bicicletário'],
  garden_ico: ['Área verde', 'Jardim'],
  air_conditioning_ico: ['Ar condicionado'],
  piped_gas_ico: ['Gás Encanado'],
  court_ico: ['Quadra'],
  game_room_ico: ['Salão de jogos'],
  default_ico: ['default_ico'],
  stage_ico: ['stage_ico', 'stage_attr']
};

// parking_lots_attr
